function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  width: "48",
  height: "48"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 7v16L9.4 38.708A4 4 0 0012.684 45h22.632a4 4 0 003.284-6.292L29 23V7M33 5a2 2 0 01-2 2H17a2 2 0 010-4h14a2 2 0 012 2zM29 11h-4M29 19h-4M29 15h-6M14.114 31h19.772",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 38a3 3 0 106 0 3 3 0 10-6 0zM31 40.5a.5.5 0 01.5.5M30.5 41a.5.5 0 01.5-.5M31 41.5a.5.5 0 01-.5-.5M31.5 41a.5.5 0 01-.5.5M27 34.5a.5.5 0 01.5.5M26.5 35a.5.5 0 01.5-.5M27 35.5a.5.5 0 01-.5-.5M27.5 35a.5.5 0 01-.5.5",
  strokeWidth: "2"
}))));